<template>
  <div class="modal fade" id="jwtTokenModal" tabindex="-1" aria-labelledby="jwtTokenModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="jwtTokenModalLabel">Your API Token</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Copy and save this API token somewhere safe. <b>This token will not be displayed again:</b></p>
          <pre id="jwtToken"><code>{{ jwtToken }}</code></pre>
          <button class="btn btn-primary" id="copyButton">Copy to Clipboard</button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';

export default defineComponent({
  props: {
    jwtToken: {
      type: String,
      required: true
    }
  },
  mounted() {
    const jwtTokenModal = document.getElementById('jwtTokenModal');
    const modal = new Modal(jwtTokenModal);
    modal.show();

    const copyButton = document.getElementById('copyButton');

    copyButton.addEventListener('click', () => {
      console.log("Copying JWT token to clipboard:", this.jwtToken);
      navigator.clipboard.writeText(this.jwtToken).then(function() {
        alert('Copied to clipboard!');
      }, function(err) {
        alert('Failed to copy text: ', err);
      });
    });
  }
});

</script>
